module.exports = __webpack_public_path__ + "img/94fab24.jpg";